import { TTabsTheme } from '../../types';

interface IStyles {
  button: string;
}

export const getTheme = (theme: TTabsTheme) => {
  return require(`./themes/${theme}.css`) as IStyles;
};
